import { ApiHttpError } from "@atlas/sdk";

/** Extrai uma mensagem legivel de um erro do backend. Quando o servidor
 *  devolve validation_error com details = { campo: "mensagem", ... },
 *  concatena os erros por campo em vez de mostrar so o generico "Dados
 *  invalidos". Fallback pro message do Error qualquer. */
export function formatBackendErr(err: unknown, fallback = "Falha na operacao."): string {
  if (err instanceof ApiHttpError) {
    if (err.details && typeof err.details === "object") {
      const entries = Object.entries(err.details as Record<string, unknown>)
        .filter(([, v]) => typeof v === "string" && (v as string).trim().length > 0)
        .map(([, v]) => v as string);
      if (entries.length > 0) return entries.join(" ");
    }
    return err.message || fallback;
  }
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}
